import { combineReducers } from "redux";
import pierMessageReducer from "./pierMessageReducer";
import setPierTutStateReducer  from "./setPierTutStateReducer";

const pierLinkTextReducer = combineReducers({
    pierMessage: pierMessageReducer,
    setTutState: setPierTutStateReducer
});

export default pierLinkTextReducer;